import loadCustomerModule from './modules/Customer.module';
import loadSessionModule from './modules/Session.module';
const loadAccountPaybackEnrichmentModule = () => ({
    hasRouter: false,
    modules: [loadCustomerModule(), loadSessionModule()],
});
export default loadAccountPaybackEnrichmentModule;
